import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GatSessionState {
  missionId: string | null;
  accessToken: string | null;
  token: string | null;
  mission: any;
}

const initialState: GatSessionState = {
  missionId: null,
  accessToken: null,
  token: null,
  mission: null,
};

const gatSessionSlice = createSlice({
  name: 'gatSession',
  initialState,
  reducers: {
    setSessionData: (
      state,
      action: PayloadAction<{ missionId: string; accessToken: string; token: string }>,
    ) => {
      state.missionId = action.payload.missionId;
      state.accessToken = action.payload.accessToken;
      state.token = action.payload.token;
    },
    setMissionData: (state, action: PayloadAction<any>) => {
      state.mission = action.payload;
    },
    clearSession: (state) => {
      state.missionId = null;
      state.accessToken = null;
      state.token = null;
    },
  },
});

export const gatSessionReducer = gatSessionSlice.reducer;
export const { setSessionData, setMissionData, clearSession } = gatSessionSlice.actions;
